module.exports = __webpack_public_path__ + "images/ds-bf-bg-billing-mobile.webp";